import styled from "styled-components";

export const Wrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.footerBg,  //transparent
  color: '#fff',
  flexShrink: 0,
  marginTop: "20px",
}));
